export const DASHBOARD = '/dashboard';
export const SETTINGS = '/settings';
export const USERS = '/users';
export const LOGIN = '/login';
